import { useMemo } from "react";
import { PieChartItem } from "../views/pie-chart/shared";
import { t } from "i18next";
import { RiskFactor, riskFactorColors, Score } from "@keita/lanepatrol-sdk";
import { OsaNode } from "../../../osaway/models/OsaNode";

const emptyRiskFactor = "null";
const riskFactorsAndEmpty = [...Object.values(RiskFactor), emptyRiskFactor];

export const useScorePieCharts = (
  filteredDistance: number,
  filteredNodes: OsaNode[]
) => {
  return useMemo(() => {
    if (!filteredNodes.length) return null;

    const data: Record<keyof Score, PieChartItem[]> = {
      global: [],
      vehicleToBicycle: [],
      bicycleToBicycle: [],
      bicycleToPedestrian: [],
      singleBicycle: [],
    };
    const wayScoreOverview: any = {};

    Object.keys(data).forEach((crashType) => {
      wayScoreOverview[crashType] = {};

      riskFactorsAndEmpty.forEach((riskFactor) => {
        wayScoreOverview[crashType][riskFactor] = filteredNodes.reduce(
          (accumulator, node) => {
            var riskFactorMatches = false;

            if (!node.score) {
              riskFactorMatches = riskFactor === emptyRiskFactor;
            } else {
              riskFactorMatches =
                node.score![crashType as keyof Score].riskFactor === riskFactor;
            }

            return riskFactorMatches ? accumulator + 1 : accumulator;
          },
          0
        );
      });
    });

    Object.entries(wayScoreOverview).forEach(([scoreType, scores]: any) => {
      const totalCount = Object.values(scores).reduce(
        (sum: number, count: any) => sum + count,
        0
      );
      data[scoreType as keyof Score] = Object.entries(scores)
        .filter(([risk, value]: any) => value > 0)
        .map(([risk, value]: any) => ({
          name: t(`score:${risk.replace("-", ".")}`),
          value: ((value / totalCount) * filteredDistance) / 1000,
          color: riskFactorColors[risk as RiskFactor],
        }));
    });
    return data;

    // eslint-disable-next-line
  }, [filteredNodes]);
};
